import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { loadRuntimeConfig } from './app/runtime-config';

/**
 * Порядок критичен (CORE-39): рантайм-конфиг грузится ДО того, как вычислится
 * `appConfig` — он читает `getRuntimeConfig().auth`, а `provideAuth`
 * потребляет эту конфигурацию СИНХРОННО, при построении массива providers.
 * Поэтому `app.config` импортируется ДИНАМИЧЕСКИ, уже ПОСЛЕ
 * `await loadRuntimeConfig()`: статический import наверху мог бы
 * вычислить `appConfig`, когда конфиг ещё не загружен (getRuntimeConfig() тогда
 * бросит внятную ошибку).
 */
async function main(): Promise<void> {
  await loadRuntimeConfig();
  const { appConfig } = await import('./app/app.config');
  await bootstrapApplication(App, appConfig);
}

main().catch((err) => {
  // Fail-fast: не бутстрапим приложение «наполовину». Невалидный/отсутствующий
  // конфиг (напр. unset AUTH_ISSUER → пустой адрес → провал zod) → видимая ошибка,
  // а не тихий редирект на собственный origin.
  // Имя файла — здесь, для того, кто чинит стенд; на странице его нет:
  // её текст по-русски целиком (REQ-SHELL-001/S2).
  console.error('Не удалось загрузить конфигурацию приложения (/config.json):', err);

  // Собираем страницу ошибки безопасными DOM-методами (textContent), без
  // innerHTML: контент статичен, но избегаем паттерна на «голом» DOM до Angular.
  const wrap = document.createElement('div');
  wrap.style.cssText =
    'font-family:system-ui;max-width:40rem;margin:4rem auto;padding:0 1rem';

  const h1 = document.createElement('h1');
  h1.textContent = 'Ошибка конфигурации';

  const p = document.createElement('p');
  p.textContent =
    'Приложение не сконфигурировано и не может быть запущено. ' +
    'Проверьте файл конфигурации и переменные окружения контейнера — подробности в консоли браузера.';

  wrap.append(h1, p);
  document.body.replaceChildren(wrap);
});
